<template>
  <div>
    <el-table :data="table" v-loading="loading" stripe size="mini">
      <el-table-column
        sortable
        :show-overflow-tooltip="true"
        align="center"
        prop="quotationNo"
        label="报价单编号"
        min-width="120"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="prjTitle"
        label="对应项目名称"
        min-width="140"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="custName"
        label="客户名称"
        min-width="120"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="quotationDate"
        label="报价日期"
        min-width="120"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="quotationExpiryDate"
        label="截止日期"
        min-width="120"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="quotationStatusName"
        label="报价单状态"
        min-width="90"
      >
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :type="scope.row.quotationStatusName === '新增' ? 'danger' : 'success'"
          >{{scope.row.quotationStatusName}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="modifyDate"
        label="修改日期"
        min-width="120"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="prjTitle"
        label="修改人员"
        min-width="140"
      ></el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </div>
    </el-table>
    <!--分页-->
    <p></p>
    <template>
      <js-pagination
              :current-page="page.curPage"
              :page-size="page.pageSize"
              :page-total="page.pageTotal"
              align="left"
              @change="handlePaginationChange"
      />
<!--      <el-pagination-->
<!--        background-->
<!--        :current-page="page.curPage"-->
<!--        :page-size="page.pageSize"-->
<!--        :total="page.total"-->
<!--        @size-change="sizeChange"-->
<!--        @current-change="currentChange"-->
<!--        layout="total, sizes, prev, pager, next, jumper, ->, slot"-->
<!--      ></el-pagination>-->
    </template>
  </div>
</template>

<script>
// import { getList } from '@api/projectManager/infoQuotation'

export default {
  components: {
  },
  props: {
    loading: {
      default: false
    },
    params: {
      default: null,
      type: Object
    },
    autoLoad: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    params: {
      handler (val) {
        if (this.autoLoad) {
          this.getData()
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true
      },
      table: [],
      // params: {
      //   prjCode: 'd978eadf-94ce-11ea-a357-000c29540cfd'
      // },
      page: {
        curPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    load (params) {
      this.getData(params)
    },
    getData (params) {
      this.$api.quotationListApi({
        ...params || this.params,
        ...this.page
      }).then(res => {
        // this.page.total = res.count
        // this.page.curPage = res.curPage
        // this.page.pageSize = res.pageSize
        this.page.pageTotal = res.body.count
        this.loading = false
        this.table = res.body.data
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页查询
    handlePaginationChange (val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.getData()
    },
    sizeChange (val) {
      this.page.curPage = 1
      this.page.pageSize = val
      this.getData()
    },
    currentChange (val) {
      this.page.curPage = val
      this.getData()
    }
  }
}
</script>
